import { useTranslation } from '@aimsos/i18n';

import ConfirmActionModal from '../member-detail/ConfirmActionModal';

/**
 * Confirm dialog before removing the direct access of a direct-only studio (destructive).
 *
 * @param {object} props
 * @param {object|null} props.studio The studio to remove, or null when closed.
 * @param {string} props.memberName
 * @param {() => void} props.onClose
 * @param {(studioId: string) => Promise<boolean>} props.onConfirm
 */
function RemoveAccessConfirm({ studio, memberName, onClose, onConfirm }) {
  const { t } = useTranslation('people-access');
  return (
    <ConfirmActionModal
      isOpen={Boolean(studio)}
      onClose={onClose}
      onConfirm={() => onConfirm(studio.id)}
      title={t('studios.removeConfirm.title', { studio: studio?.name })}
      message={t('studios.removeConfirm.message', { name: memberName })}
      confirmLabel={t('studios.removeConfirm.confirm')}
      confirmVariant="danger"
    />
  );
}

export default RemoveAccessConfirm;
